import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import 'dayjs/locale/cs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/hu';

dayjs.extend(utc);

